import { Component, OnInit } from '@angular/core';

import { Ponto } from "../shared/ponto.model";
import { pontosModuleName } from "../shared/data.service";
import { PontoApiService } from "../shared/ponto-api.service";
import { PontoNavigationService } from "../shared/ponto-navigation.service";
import {EnderecoService} from "../../../estruturas/enderecos/shared/endereco.service";
import {PontoService} from "../shared/ponto.service";
import {ViagemService} from "../../shared/viagem.service";
import {configuracaoModuleName} from "../../../shared/services/data.service";
import {viagensModuleName} from "../../shared/data.service";

@Component({
    template: require('./ponto-list.component.html'),
    styles: [require('./ponto-list.component.css')]
})
export class PontoListComponent implements OnInit {
    list: Ponto[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    pontosModuleName: any = pontosModuleName;
    configuracaoModule: any = configuracaoModuleName;
    module: any = viagensModuleName;

    constructor(
        private _pontosApiService: PontoApiService,
        private _pontoNavigationService: PontoNavigationService,
        private _pontoService: PontoService,
        private _enderecoService: EnderecoService,
        private _viagemService: ViagemService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickGoToConfig() {
        this._viagemService.goToSetting()
    }

    clickNew() {
        this._pontoService.clearSessionStorage();
        this._pontoNavigationService.goToNew();
    }

    private getAll() {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: any, lenX: any;
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].endereco) {
                        Response[x].address = this._enderecoService.getAddress(Response[x].endereco);
                    }
                }

                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._pontosApiService.onGetAll(onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/ponto-list/ponto-list.component.ts
 **/